import { useMutation, useQuery, useQueryClient } from "react-query";
import CourseSkillsService from "./CourseSkillsService";

const useCourseSkills = () => {
  const queryClient = useQueryClient();

  const { data: courses = [] } = useQuery(
    "courses",
    CourseSkillsService.getAllCourses
  );
  const { data: skills = [] } = useQuery(
    "skills",
    CourseSkillsService.getAllSkills
  );
  const { data: coursesWithSkillsResponse = [] } = useQuery(
    "coursesWithSkills",
    CourseSkillsService.getCoursesWithSkills
  );

  const assignMutation = useMutation(
    ({ courseId, skillIds }) =>
      CourseSkillsService.assignSkillsToCourse(courseId, skillIds),
    {
      onSuccess: () => queryClient.invalidateQueries("coursesWithSkills"),
    }
  );

  const removeSkillMutation = useMutation(
    ({ courseId, skillId }) =>
      CourseSkillsService.removeSkillFromCourse(courseId, skillId),
    {
      onSuccess: () => queryClient.invalidateQueries("coursesWithSkills"),
    }
  );

  return {
    courses: courses.data || [],
    skills: skills.data || [],
    coursesWithSkills: coursesWithSkillsResponse.data || [],
    assignSkills: assignMutation.mutate,
    isAssigning: assignMutation.isLoading,
    removeSkillFromCourse: removeSkillMutation.mutate,
  };
};

export default useCourseSkills;
